/**
 * Rolling date-range preset codes persisted on saved stats filters (stats tab).
 * Must match {@link STATS_DATE_RANGE_PRESETS} in the frontend except `custom`.
 * For Media Devoted | Created By Ciro Autiero
 */

export const STATS_SAVED_FILTER_ROLLING_PRESET_CODES = [
  "today",
  "yesterday",
  "last-24-hours",
  "last-48-hours",
  "last-3-days",
  "last-7-days",
  "last-14-days",
  "this-month",
  "last-30-days",
  "last-month",
  "this-year",
  "last-year",
] as const;

export type StatsSavedFilterRollingPresetCode =
  (typeof STATS_SAVED_FILTER_ROLLING_PRESET_CODES)[number];

export function isStatsSavedFilterRollingPreset(
  code: string | null | undefined,
): code is StatsSavedFilterRollingPresetCode {
  return (
    code != null &&
    code !== "" &&
    (STATS_SAVED_FILTER_ROLLING_PRESET_CODES as readonly string[]).includes(code)
  );
}
